import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';

/* Dialogs */
import AddAccessoriesDialog from '../../dialogs/addAccessoriesDialog';
import ExportProductPriceInfoOverlayDialog from '../../dialogs/exportProductPriceInfoOverlayDialog';
import SuccessPriceTemplateConfirmation from '../../dialogs/successPriceTemplateConfirmation';

import { DATE_TIME_FORMAT } from '../../common/messageConstants';
import ProductSortableComponent from './productSortable';
import ChangeZipCode from '../common/changeZipCode';

/* Actions */
import {
    savePriceTagsSku,
    addToList,
    saveToList,
    addToCart,
    resetAvailabilityToList,
    saveAvailabilityToList,
} from '../../../redux/actions';

class List extends Component {

	constructor(props) {
    	super(props);
		this.state = {
			showAddAccessories: false,
			errorMessage: "",
			isSelectAll: true,
			showExportProductPriceDialog: false,
			showSuccessPriceTemplateConfirmation: false,
		};
		this.validateFP = this.validateFP.bind(this);
        this.validateFDD = this.validateFDD.bind(this);
        this.sortEndOfItems = this.sortEndOfItems.bind(this);
	}
	componentDidMount() {
		this.checkAvailabilityAndAll();
	}
	componentWillReceiveProps(nextProps) {
        const self = this;
        if(
			(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) ||
			(self.props.state.user.selectedADC && self.props.state.user.selectedADC !== nextProps.state.user.selectedADC) ||
            (self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode)
		) {
			self.props.resetAvailabilityToList();
			setTimeout(() => {
				self.checkAvailabilityAndAll();
			}, 40);
		}
	}
	checkAvailabilityAndAll() {
		const self = this;
	    const { selectedAccount } = self.props.state.user;
	    if (!this.props.state.list.availability.length) {
			let skuList = [];
	      	self.props.state.list.list.responseObject && self.props.state.list.list.responseObject.wishlistItems && self.props.state.list.list.responseObject.wishlistItems.length
	        	&& self.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
					if (item.itemType === 'M' || item.itemType === 'A') {
						skuList.push({ "sku": item.item });
					}
	        	});
			const zipCode = self.props.customZipCode;
			zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
			      	skuList.length && self.props.checkAvailabilityGeneric(skuList, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${zipCode}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, 'list', true, response => {
			      	});
				}
			});
	    }
        self.props.fireGTMTag('List View', {
			numOfWishlistItems: self.props.state.list.list.responseObject ? self.props.state.list.list.responseObject.wishlistItems.length : 0
		});
		const { pimDataForList } = self.props.state.list;
		if(pimDataForList.length === 0) {
			self.props.getPimDataForListItem();
		}
	}
	componentWillMount() {
		const self = this;
		const { list } = self.props.state.list;
		if(list.responseObject) {
			list.responseObject.wishlistItems.forEach(item => {
				item.selected = false;
			});
			self.props.saveToList(list);
		}
	}
	showAddAccessories(sku, itemDescription, event) {
		event.preventDefault();
		this.setState({
			accessoriesSku: sku,
			itemDescription: itemDescription,
			showAddAccessories: false
		}, () => {
			this.setState({
				showAddAccessories: true
			})
		});
	}
	showExportProductPrice(event) {
		event.preventDefault();
        const self = this;
		const selectedItems = [];
		self.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
			if (item.selected && item.selected === true) {
				selectedItems.push(item);
			}
		});
		self.setState({
			listItems: self.props.state.list.list.responseObject.wishlistItems,
			selectedListItems: selectedItems,
			showExportProductPriceDialog: false
		}, () => {
			self.setState({
				showExportProductPriceDialog: true
			});
		});
	}
    handleDeleteAll(event) {
        event.preventDefault();
        const self = this,
            { selectedAccount, userDetails } = self.props.state.user;
        self.props.resetAvailabilityToList();
        const payload = {
            accountNumber: selectedAccount.ACCOUNTNUMBER,
            createdDate: moment().format('MM/DD/YYYY'),
            updatedDate: moment().format('MM/DD/YYYY'),
            userId: userDetails.sso,
            wishlistItems: []
        };
        const sku = [];
        self.props.state.list.list.responseObject.wishlistItems.forEach(item => {
            sku.push(item.item);
        });
        self.props.fireGTMTag('Remove from List', {
            prodSku: sku.join(',')
        });
        self.props.addToList(payload, response => {
            if (response.status) {
                if (response.responseObject) {
                    self.props.saveToList(response);
                }
            } else {
                browserHistory.push('/error');
            }
        });
    }
    handleDelete(sku, event) {
        event.preventDefault();
        const self = this,
            { selectedAccount, userDetails } = self.props.state.user;
        const wishlistItems = _.pullAllBy(self.props.state.list.list.responseObject.wishlistItems, [{item: sku}], 'item');
        const availability = _.uniq(_.pullAllBy(self.props.state.list.availability, [{ 'sku': sku }], 'sku'));
        self.props.saveAvailabilityToList({responseObject: availability});
        const payload = {
            accountNumber: selectedAccount.ACCOUNTNUMBER,
            createdDate: moment().format('MM/DD/YYYY'),
            updatedDate: moment().format('MM/DD/YYYY'),
            userId: userDetails.sso,
            wishlistItems
        };
        self.props.fireGTMTag('Remove from List', {
			prodSku: sku
		});
        self.props.addToList(payload, response => {
            if (response.status) {
                if (response.responseObject) {
                    self.props.saveToList(response);
                }
            } else {
                browserHistory.push('/error');
            }
        });
    }
    handleRemoveAllPackage(packageName, event) {
        event.preventDefault();
        const self = this,
            { selectedAccount, userDetails } = self.props.state.user;
        let wishlistItems = self.props.state.list.list.responseObject.wishlistItems;
        wishlistItems = _.pullAllBy(wishlistItems, [{ 'packageName': packageName }], 'packageName');
        const payload = {
            accountNumber: selectedAccount.ACCOUNTNUMBER,
            createdDate: moment().format('MM/DD/YYYY'),
            updatedDate: moment().format('MM/DD/YYYY'),
            userId: userDetails.sso,
            wishlistItems
        };
        self.props.addToList(payload, response => {
            if (response.status) {
                if (response.responseObject) {
                    self.props.saveToList(response);
                }
            } else {
                browserHistory.push('/error');
            }
        });
    }
    handleSelectAllPackage(item, packageName, event) {
        const self = this;
        const payload = JSON.parse(JSON.stringify(self.props.state.list.list));
        const wishlistItems = this.props.state.list.list.responseObject.wishlistItems
        const items = _.filter(wishlistItems, { 'packageName': packageName });
        payload.responseObject.wishlistItems.forEach((item, index) => {
            if (items.findIndex(x => x.item === item.item) >= 0 && items.findIndex(x => x.packageName === item.packageName) >= 0) {
                item.selected = event.target.checked;
            }
        });
        // TO DO:
        item.packageChecked = true;

        // if(!event.target.checked) {
        //     self.setState({
        //         isSelectAll: true
        //     })
        // }
        self.props.saveToList(payload);
    }
    handleSelect(indx, availableQty, event) {
        const self = this;
        const payload = JSON.parse(JSON.stringify(self.props.state.list.list));
        payload.responseObject.wishlistItems.forEach((item, index) => {
            if (index === indx) {
                item.selected = event.target.checked;
                // saving this available qty for tagging while adding to cart
                item.availableQty = availableQty;
            }
        });

        if (!event.target.checked) {
            self.setState({
                isSelectAll: true
            });
        }
        self.props.saveToList(payload);
    }
    handleSelectAll(event) {
        event.preventDefault();
        const self = this;
        const payload = JSON.parse(JSON.stringify(self.props.state.list.list));
        payload.responseObject.wishlistItems.map((item, index) => {
            item.selected = this.state.isSelectAll
            return null;
        })
        self.setState({
            isSelectAll: !this.state.isSelectAll
        });
        self.props.saveToList(payload);
    }
	handleProductSpec(item, index, availableQty, event) {
		event && event.preventDefault();
        const self = this;
        // Fire gtm tag of product click
        const data = self.props.getBrandCategory(item.item, 'list');
        self.props.fireGTMTag('Product Click', {
			ecommerce: {
				currencyCode: 'USD',
				click: {
					actionField: {
						list: undefined,
					},
					products: [{
						name: item.itemDescription,
						id: item.item,
						price: undefined,
						brand: data.brand,
						category: data.category,
						variant: undefined,
						position: (index + 1).toString(),
						dimension70: availableQty === '0' ? 'yes' : 'no'
					}]
				}
			}
		});
		browserHistory.push("/product-specs/product-number/" + item.item);
	}
	handleAddToCart(event) {
	    event.preventDefault();
        const self = this;
	    let selectedCount = 0;
	    const selectedItems = [];
	    const cartItems = [];
		self.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
			if (item.selected && item.selected === true) {
				selectedCount += 1;
				selectedItems.push(item);
			}
		})
	    if (selectedCount) {
			const { selectedAccount, userDetails, selectedPriceSource } = self.props.state.user;
			let oldCart = self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems
				? self.props.state.cart.cart.responseObject.cartItems
				: [];
			let product = [];
			oldCart.length > 0 && oldCart.forEach((item, index) => {
				product.push(item.item);
			});
            const products = [];
	      	selectedItems.forEach((item, index) => {
	        	if (product.indexOf(item.item) < 0) {
                    const data = self.props.getBrandCategory(item.item, 'list');
                    products.push({
                        name: item.itemDescription,
                        id: item.item,
                        price: undefined,
                        brand: data.brand,
                        category: data.category,
                        variant: undefined,
                        quantity: item.quantity,
                        overpackQuantityRequired: item.overpackQuantityRequired,
                        packageQuantity:item.packageQuantity,
                        dimension70: item.availableQty === '0' ? 'yes' : 'no'
                    });
                    // delete availableQty as it was read before so no need to keep it in payload
                    delete item.availableQty;
					oldCart.push({
						...selectedItems[index],
						agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
						createdDate: moment().format(DATE_TIME_FORMAT),
						updatedDate: moment().format(DATE_TIME_FORMAT),
					});
				}
	      	});
			oldCart.forEach((item, index) => {
				cartItems.push({
                    ...item,
					itemType: !item.itemType || item.itemType === '' ? "M" : item.itemType,
					item: item.item,
					quantity: item.quantity,
					itemDescription: item.itemDescription,
					agreementNumber: item.agreementNumber,
					createdDate: item.createdDate,
					updatedDate: item.updatedDate,
                    overpackQuantityRequired: item.overpackQuantityRequired,
                    packageQuantity:item.packageQuantity
				});
			});
            if (products.length) {
                let cartCount = 0;
        		cartItems.forEach((itm, index) => {
    				cartCount += parseInt(itm.quantity, 10);
        		});
                self.props.fireGTMTag('Add to Cart', {
        			addToCartLocation: 'cart',
        			cartQuantity: cartCount,
        			ecommerce: {
        				currencyCode: 'USD',
        				add: {
        					actionField: {
        						list: undefined,
        						position: undefined,
        					},
        					products
        				}
        			}
        		});
            }
			self.props.addToCart({
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems: cartItems
			}, response => { });
	    } else {
			self.setState({ errorMessage: "Please select at least one item and try again." })
	    }
	}
    // event for close dialog
    handleDialog(dialog, flag, isEmailSent, event) {
        event && event.preventDefault();
        const self = this;
        if (isEmailSent) {
            self.setState({
                showSuccessPriceTemplateConfirmation: false,
            }, () => {
                self.setState({
                    showSuccessPriceTemplateConfirmation: true,
                    showExportProductPriceDialog: flag
                });
            });
        }
        else {
            self.setState({
                ['show' + dialog]: false
            }, () => {
                self.setState({
                    ['show' + dialog]: flag
                })
            })
        }
    }

	handleDialogStatusRunExportConfirm(flag, event) {
		event && event.preventDefault();
		this.setState({
			showSuccessPriceTemplateConfirmation: flag
		});
	}

	handleCreatePriceTags(event) {
		event.preventDefault();
		let selectedItems = _.filter(this.props.state.list.list.responseObject.wishlistItems, ['selected', true]);
		if (selectedItems.length > 0) {
			this.props.savePriceTagsSku(selectedItems);
			browserHistory.push("/createpricetags");
		} else {
			this.setState({
				errorMessage: "Please select at least one product to proceed"
			});
		}
	}

	validateFP(item) {
		const self = this;
		const { pimDataForList: pimData } = this.props.state.list;
		let finalProductionDate = null;
		const pimItemData = pimData && _.find(pimData, {item_number: item.sku});
		if(pimItemData && pimItemData.geego_final_production_date && pimItemData.geego_final_production_date !== 'NULL') {
			finalProductionDate = pimItemData.geego_final_production_date;
		}
		return self.props.checkIfFP({
			finalProductionDate: finalProductionDate,
			availableQty: item.availableQty,
			etaDate: item.etaDate
		});
	}

    validateFDD(item) {
		const self = this;
		const { pimDataForList: pimData } = this.props.state.list;
		let firstDistributionDate = null;
		const pimItemData = pimData && _.find(pimData, {item_number: item.sku});
		if(pimItemData && pimItemData.geego_distribution_start_date && pimItemData.geego_distribution_start_date !== 'NULL') {
			firstDistributionDate = pimItemData.geego_distribution_start_date;
		}
		return self.props.validateFDD({
			firstDistributionDate,
			availableQty: item.availableQty,
			intransitQty: item.intransitQty,
			etaDate: item.etaDate,
		});
	}
    sortEndOfItems(wishlistItems) {
        const self = this,
            { selectedAccount, userDetails } = self.props.state.user;
        const payload = {
            accountNumber: selectedAccount.ACCOUNTNUMBER,
            createdDate: moment().format('MM/DD/YYYY'),
            updatedDate: moment().format('MM/DD/YYYY'),
            userId: userDetails.sso,
            wishlistItems
        };
        self.props.saveToList({
            responseObject: {
                wishlistItems
            }
        });
        setTimeout(() => {
            self.props.addToList(payload, response => {
                if (response.status) {
                    if (response.responseObject) {
                        self.props.saveToList(response);
                    }
                } else {
                    browserHistory.push('/error');
                }
            });
        }, 10);
    }
	render() {
		const self = this;
	    const isThisAccountRestricted = self.props.isThisAccountRestricted;
		let skuListt = [];
        if (this.props.state.list.list.responseObject && this.props.state.list.list.responseObject.wishlistItems) {
            this.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
                skuListt.push(item.item);
    		});
        }
        return <div>
            <h1 className="pageTitle">List</h1>
            <p className="red">{this.state.errorMessage}</p>
            <ChangeZipCode
                saveCustomADC={self.props.saveCustomADC}
                customADC={self.props.customADC}
                selectedAccount={self.props.state.user.selectedAccount}
                getShippingAddressesDetails={this.props.getShippingAddressesDetails}
                acceptNumbersOnly={this.props.acceptNumbersOnly}
                handleSelectZipCode={this.props.saveCustomZipCode}
                zipCode={this.props.customZipCode}
                typeOfAccount={self.props.getSelectedAccountType()}
                showInStockFilter={false}
            />
            <form onSubmit={this.props.doNothing}>
                {this.props.state.list.list.responseObject && this.props.state.list.list.responseObject.wishlistItems && this.props.state.list.list.responseObject.wishlistItems.length
                    ? this.props.state.list.availability.length > 0 &&
                        <div className="columns listPageColumns">
                            <div className="column listPageLeftColumn">
                                <div className="textRight">
                                    <p>
                                        <a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print</a>
                                            &nbsp; &nbsp; &nbsp;
                                        <a className="withIcon withExportIcon noUnderline bold uppercase" onClick={this.showExportProductPrice.bind(this)} href="">Export Product / Price Info</a>
                                    </p>
                                </div>
                                <table className="dataTable listPageTable withAlternatingTbodyElements viper1">
                                    <thead>
                                        <tr>
                                            <th className="delete">
                                                <a className="deleteAllLink" href="" onClick={this.handleDeleteAll.bind(this)}>Delete All</a>
                                            </th>
                                            <th className="productPhoto">Product</th>
                                            <th className="product">&nbsp;</th>
                                            <th className="availability">Avail.</th>
                                            <th className="nextavailability">Next<br />Avail.</th>
                                            <th className="ETA">ETA</th>
                                            <th className="select">
                                                <a className="selectAllCheckboxesLink" onClick={this.handleSelectAll.bind(this)} name="selectedProduct" href="">
                                                {this.state.isSelectAll ? "Select" : "Deselect"} All</a>
                                            </th>
                                        </tr>
                                    </thead>
                                    <ProductSortableComponent
                                        items={this.props.state.list.list.responseObject.wishlistItems}
                                        handleRemoveItemFromPage={this.handleRemoveItemFromPage}
                                        sortEndOfItems={this.sortEndOfItems}
                                        self={this}
                                        availabilities={this.props.state.list.availability}
                                        skuListt={skuListt}
                                        handleProductSpec={this.handleProductSpec}
                                    />
                                    <tbody></tbody>
                                </table>
                            </div>
                            <div className="column listPageRightColumn">
                                <p className="bold">Available Actions for Selected Products</p>
                                <p>
                                    <input type="button" className="blockButton greenButton" onClick={this.handleAddToCart.bind(this)} defaultValue="Add to Cart" />
                                </p>
                                {!isThisAccountRestricted && <p>
                                    <a href="" className="blockButton blueButton" onClick={this.props.handleCreateBrochure.bind(this, 2, 'list')}>Create Brochure</a>
                                </p>}
                                {!isThisAccountRestricted && <p>
                                    <input type="button" className="blockButton blueButton" onClick={this.handleCreatePriceTags.bind(this)} defaultValue="Create Price Tags" />
                                </p>}
                            </div>
                        </div>
                    :   <p>There are currently no products in your product List.</p>
                }
                <div className="clear" />
            </form>
            {this.state.showAddAccessories
                ? <AddAccessoriesDialog
                    checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
                    getShippingAddressesDetails={this.props.getShippingAddressesDetails}
                    makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
                    accessoriesSku={this.state.accessoriesSku}
                    itemDescription={this.state.itemDescription}
                    handleDialog={this.handleDialog.bind(this)}
                    showDialog={true}
                    getZipCode={this.props.getZipCode}
                    getLegacyCustCode={this.props.getLegacyCustCode}
                    getLocalStorageVar={this.props.getLocalStorageVar}
                    manipulateProductSpecsData={this.props.manipulateProductSpecsData}
                    isPricingAccess={this.props.isResponsibilityExists("Price")}
                    getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
                />
                : null
            }
            {this.state.showExportProductPriceDialog
                ? <ExportProductPriceInfoOverlayDialog
                    getOrgAttributesByAttributeName={this.props.getOrgAttributesByAttributeName}
                    isAccessToMAPGuidelines={this.props.isAccessToMAPGuidelines}
                    getZipCode={() => this.props.customZipCode}
                    getLegacyCustCode={this.props.getLegacyCustCode}
                    listItems={this.state.listItems}
                    selectedListItems={this.state.selectedListItems}
                    isPricingAccess={this.props.isResponsibilityExists("Price")}
                    isPriceDiscountAccess={this.props.isResponsibilityExists("Price Discounts")}
                    handleDialog={this.handleDialog.bind(this)}
                    showDialog={true}
                    exportingFromWhere={'list'}
                    getShippingAddressesDetails={this.props.getShippingAddressesDetails}
                    typeOfAccount={this.props.getSelectedAccountType()}
                    customADC={this.props.customADC}
                />
              : null
            }
            {this.state.showSuccessPriceTemplateConfirmation ? <SuccessPriceTemplateConfirmation saveTemplateOrNot={false} handleDialogStatus={this.handleDialogStatusRunExportConfirm.bind(this)} showDialog={true} /> : null}
        </div>
    }
}

const mapStateToProps = (state) => {
    return { state };
};

const mapDispatchToProps = (dispatch) => ({
    savePriceTagsSku: (data) => dispatch(savePriceTagsSku(data)),
    addToList: (payload, callback) => dispatch(addToList(payload, callback)),
    saveToList: (payload) => dispatch(saveToList(payload)),
    resetAvailabilityToList: () => dispatch(resetAvailabilityToList()),
    saveAvailabilityToList: (data) => dispatch(saveAvailabilityToList(data)),
    addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
});

List = connect(mapStateToProps, mapDispatchToProps)(List);
export default List;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/List/index.js